import { NavLink } from "react-router-dom";
import usePathWithSlug from "@/hooks/usePathWithSlug";
import { cn, isLinkActive } from "@/lib/utils";
import { HeaderLinksProps } from "./types";

const HeaderLinks = ({ links, className, onItemClick }: HeaderLinksProps) => {
  const pathWithSlug = usePathWithSlug();

  if (!links?.length) return null;

  return (
    <nav className={cn("flex flex-col gap-2 text-center lg:flex-row lg:gap-6 lg:text-left", className)}>
      {links.map((link, index) => (
        <NavLink
          key={link.value + index}
          to={pathWithSlug(link.value)}
          target={link.external ? "_blank" : "_self"}
          className={({ isActive }) =>
            cn(
              "font-['Inter'] text-[13px] font-normal leading-tight",
              "text-[#B0B0B0] transition-colors hover:text-white/90",
              "rounded-md px-2 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
              isLinkActive(isActive, link.value) && "text-white",
            )
          }
          onClick={onItemClick}
        >
          {link.text}
        </NavLink>
      ))}
    </nav>
  );
};

export default HeaderLinks;
